import script from "./postulaciones.vue?vue&type=script&setup=true&lang=js"
export * from "./postulaciones.vue?vue&type=script&setup=true&lang=js"

import "./postulaciones.vue?vue&type=style&index=0&id=437fa7e6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437fa7e6"]])

export default __exports__